import React, {useEffect, useState} from "react";
import {Link, useNavigate} from 'react-router-dom'
import {Paths} from "../paths";
import {useAuth} from "../store/AuthContext";

const Notfoundpage = () => {
    const {isAuth} = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);
        if (!isAuth) {
            navigate(Paths.home);
        }
        setLoading(false);
    }, []);

    if (loading) {
        return <div className={"loading"}>...</div>;
    }

    return (
        <div className="d-flex flex-column">
            <div className={"h4"}>Страница не найдена</div>
            <Link to={Paths.home}>На главную</Link>
        </div>
    )
}

export {Notfoundpage};